export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: ['VFAIRORGANIZATION_TEMPLATE', data => ({})],
    '/organizations': {
        authorize: true,
        template: [
            'VFAIRORGANIZATION_TEMPLATE',
            data => ({
                vfairId: data.vfairId,
                id: data.vfairId + '_' + data.organizationId,
                organizationId: data.organizationId,
                backgroundImage: data.backgroundImage,
                email: data.email,
                facebook: data.facebook,
                instagram: data.instagram,
                linkedIn: data.linkedIn,
                logo: data.logo,
                phone: data.phone,
                presentation: data.presentation,
                status: data.status,
                tagline: data.tagline,
                title: data.title,
                twitter: data.twitter,
                url: data.url,
                vimeo: data.vimeo,
                weChat: data.weChat,
                youTube: data.youTube,
            }),
        ],
        GET: {},
    },
};
